import React from 'react';
import PropTypes from 'prop-types';
import './Mask.scss';

function Mask(props) {
    return <div className='r-mask' onClick={props.onClick}></div>;
}

Mask.propTypes = {};
Mask.defaultProps = {};

export default Mask;
